import { render } from "./faqSection.vue?vue&type=template&id=34f6d006&scoped=true"
import script from "./faqSection.vue?vue&type=script&lang=js"
export * from "./faqSection.vue?vue&type=script&lang=js"

import "./faqSection.vue?vue&type=style&index=0&id=34f6d006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f6d006"]])

export default __exports__